import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { withRouter } from 'react-router';
import List from 'yoda-core-components/lib/components/List/List';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ArrowRight from 'yoda-core-components/lib/assets/svg/ArrowRight.svg';
import ArrowLeft from 'yoda-core-components/lib/assets/svg/ArrowLeft.svg';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import ProductCartridgeReducer from '../../reducers/ProductCartridgeReducer';
import {
    getScrolledElementOffSet,
    getDefaultOffSet,
    setDefaultOffSet,
} from '../../helpers/Utils/scrollPosition';
import ProductCard from '../ProductCard/ProductCard';
import actions from '../../actions/ProductCartridgeAction';
import QuickAddToCart from '../QuickAddTocart/QuickAddToCart';
import config from '../ProductCard/ProductCard.config';
import LoaderAction from '../../actions/LoadingAction';
import { selectProduct } from '../../actions/MiniPDPAction';
import { showLazy } from '../../lazy/actions/LazyAction';
import { watchEnsightenErrorRequest } from '../../sagas/ProductCartridgeSaga';
import getUrgencyStatementsAction from '../../actions/UrgencyMessagingAction';
import UrgencyMessage from '../UrgencyMessageContainer/UrgencyMessageLazy';
import * as styles from './YodaProductCartridge.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const add = (param1, param2) => param1 + param2;
/* istanbul ignore next */
const subtract = (param1, param2) => param1 - param2;

/* istanbul ignore next */
const calculateScrollPixel = ({
    productPanesDisplayed,
    totalProductPanes,
    scrollPixels,
    scrolledPanes,
    productPaneWidth,
    scrollToRight,
    remainingWrapperWidth,
    disableRightArrow,
    isCouponRecommendationsModal,
}) => {
    const operator = scrollToRight ? subtract : add;

    // Calculate remaining(hidden panes) product panes in container to display
    const remainingProductsPanes = scrollToRight
        ? totalProductPanes - productPanesDisplayed - scrolledPanes
        : scrolledPanes;

    let offSetValue = 0;
    if (isCouponRecommendationsModal) {
        offSetValue = scrollToRight ? 1 : 2;
    }
    // Calculate product panes to show. It depends on the remaining panes and container size.
    /* istanbul ignore next */
    const numberOfPanesToMove =
        remainingProductsPanes >= productPanesDisplayed
            ? productPanesDisplayed - offSetValue
            : remainingProductsPanes;

    // Calculate next scroll position
    let scrollX = numberOfPanesToMove * productPaneWidth;

    // Calculate the total number of panes which are scrolled
    const productPanesScrolled = scrollToRight
        ? scrolledPanes + numberOfPanesToMove
        : scrolledPanes - numberOfPanesToMove;

    // Calculate the total panes which are displaced from its original position
    const migratedProductPanes = scrollToRight
        ? add(productPanesScrolled, productPanesDisplayed)
        : productPanesScrolled;

    if (totalProductPanes === migratedProductPanes || disableRightArrow) {
        scrollX -= remainingWrapperWidth;
    }
    const scrollContentBy = operator(scrollPixels, scrollX);

    return {
        scrollContentBy,
        migratedProductPanes,
        productPanesScrolled,
    };
};

/* istanbul ignore next */
const miniPDP = (item, url, id, context) => {
    const themeConfig = {
        wrapperClass: cx('cartridgeWrapper', 'noPad'),
        customClassNameClass: styles.cartridgeAddToCartBlock,
        buttonCustomClass: styles.cartridgeMiniPDPBtn,
    };
    return (
        /* eslint-disable no-return-assign */
        <div ref={(node) => (context.quickAddToCartRefs[id] = node)}>
            <QuickAddToCart
                enableMiniPDP={item.enableMiniPDP}
                ppId={item.id}
                url={url}
                iconStyle
                automationId="miniPDPAddtoCart"
                location="hp-cartridge"
                themeConfig={themeConfig}
            />
        </div>
    );
};

const validGalleryRoutes = ['/s', '/g/'];

/* istanbul ignore next */
export class YodaProductCartridge extends PureComponent {
    static defaultProps = {
        customRenderProductCard: false,
        cartridgeListRenderer: null,
        theme: 'compact',
        productPane: null,
        productCatridgeTheme: '',
        deviceType: {
            isMobile: false,
            isDesktop: true,
            isTablet: false,
        },
        productCartridgeList: [],
        cartridgeHeader: '',
        onPaneRender: noop || false,
        onPaneClick: false,
        hasTitle: true,
        isPLAEnabled: false,
        disableLazyLoad: false,
        prodCatridgeWrapper: '',
        showPaneLoader: false,
        showImageLoader: false,
        pageType: '',
        panelType: '',
        panelTitle: '',
        enableMiniPDP: false,
        pricingConfig: {},
        actions: {},
        showPricing: true,
        productItemClass: '',
        enableGridViewInCertona: false,
        enableUrgencyMessagingOnATC: false,
        preferences: {},
        urgencyMessages: {},
        highlightCardSlot: false,
        listBodyClassTheme: '',
        displayPartial: true,
        isCouponRecommendationsModal: false,
        featureFlags: {},
        fromMiniPDP: false,
        criteriaName: '',
        isDrawer: false,
        isNative: false,
        location: {},
    };

    static propTypes = {
        /**
         * Each product cartridge slot requires unique slotId because a page can consists of multiple product cartridge slots.
         */
        slotId: PropTypes.string.isRequired,
        /**
         * The custom render function for rendering product cards
         */
        cartridgeListRenderer: PropTypes.func,
        /**
         * Flag to check if the lazy loading is disabled
         */
        disableLazyLoad: PropTypes.bool,
        /**
         * Flag to check if renderProductCard method has to be called.
         */
        customRenderProductCard: PropTypes.bool,
        theme: PropTypes.string,
        /**
         * The product pane object that is needed for scrolling if a custom render method is used.
         */
        productPane: PropTypes.object,
        productCatridgeTheme: PropTypes.string,

        deviceType: PropTypes.object,
        /**
         * list of items to be shown in cataridge.
         * format: productCartridgeList: [{
         *  name: <name>,
         *   id: <ppid>,
         *   imageURL: <complete url>,
         *   rating: <number>,
         *   reviews: <number>,
         *   priceDetails: <{amounts: [], manufacturerAdvertised: <>, marketingLabel: <>, id: <>}>,
         *   skuId: <skuid>,
         *   linkURL: <pdp url>
         * }, ...]
         */
        productCartridgeList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        /**
         * Text to be displayed as header
         */
        cartridgeHeader: PropTypes.string,
        /**
         * callback on pane render
         */
        onPaneRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]), // added to handle this warning - Failed prop type: Invalid prop `onPaneRender` of type `boolean` supplied to `YodaProductCartridge`, expected `function`.
        /**
         * callback on pane click
         */
        onPaneClick: PropTypes.func,
        /**
         * Flag to find pla ads
         */
        isPLAEnabled: PropTypes.bool,
        prodCatridgeWrapper: PropTypes.string,
        /**
         * Flag to show pane loader or not
         */
        showPaneLoader: PropTypes.bool,
        /**
         * Flag to show image loader or not
         */
        showImageLoader: PropTypes.bool,
        /**
         * Flag to show minipdp
         */
        enableMiniPDP: PropTypes.bool,

        /**
         * pageType to send Event
         */
        pageType: PropTypes.string,

        /**
         * panelType to send Event
         */
        panelType: PropTypes.string,

        /**
         * panelTitle to send Event
         */
        panelTitle: PropTypes.string,
        /* *
         * Flag to Show either new product Price/Card Format or Not
         */
        pricingConfig: PropTypes.object,
        showPricing: PropTypes.bool,
        productItemClass: PropTypes.string,
        actions: PropTypes.object,
        enableGridViewInCertona: PropTypes.bool,
        enableUrgencyMessagingOnATC: PropTypes.bool,
        preferences: PropTypes.object,
        urgencyMessages: PropTypes.object,
        isNative: PropTypes.bool,
        highlightCardSlot: PropTypes.bool,
        listBodyClassTheme: PropTypes.string,
        displayPartial: PropTypes.bool,
        hasTitle: PropTypes.bool,
        isCouponRecommendationsModal: PropTypes.bool,
        featureFlags: PropTypes.object,
        fromMiniPDP: PropTypes.bool,
        criteriaName: PropTypes.string,
        isDrawer: PropTypes.bool,
        location: PropTypes.object.isRequired,
    };

    state = {
        listStyle: {},
        disableLeftArrow: true,
        disableRightArrow: false,
        currentDotIndex: 1,
        cardsToRender: 0,
    };

    componentDidMount() {
        const {
            disableLazyLoad,
            deviceType,
            productCartridgeList,
            enableUrgencyMessagingOnATC,
            preferences,
            location: { pathname = '' },
            featureFlags: { enableAnchoring },
        } = this.props;
        this.listenScrollEvent = this.listenScrollEvent.bind(this);
        // fix for defect - MNPDPYODA-6719
        // window.addEventListener('resize', this.renderCartridge);
        window.addEventListener('orientationchange', this.renderCartridge(true));
        this.renderCartridge();
        if (disableLazyLoad && !deviceType.isDesktop) {
            this.updateDotsPosition();
        }
        if (productCartridgeList && productCartridgeList.length > 0) {
            this.fireEnsightenEvent(productCartridgeList);
            const ppIds = productCartridgeList.map((obj) => obj.id);
            enableUrgencyMessagingOnATC &&
                !isEmpty(ppIds) &&
                this.props.actions.getUrgencyStatementsAction({
                    ppid: ppIds,
                    apiURL: preferences.URGENCY_API_URL,
                });
        }
        const isGallery = validGalleryRoutes.some((route) => pathname.includes(route));
        if (isGallery && enableAnchoring) {
            const scrollToCartridgeVal = LocalStorage.getData('scrollToCartridge', true);
            const parsedJson = scrollToCartridgeVal && JSON.parse(scrollToCartridgeVal);
            const galleryScrollToVal =
                parsedJson?.val && parsedJson.key === window.location.href ? parsedJson.val : {};
            if (!isEmpty(parsedJson)) {
                if (!isEmpty(galleryScrollToVal)) {
                    const { galleryScrollTo } = galleryScrollToVal;
                    if (
                        /* adding replace as few times when we came back from pdp to plp 
                        same data populating same slot name with different number */
                        galleryScrollTo.replace(/[0-9]/g, '') ===
                        this.props.slotId.replace(/[0-9]/g, '')
                    ) {
                        this.wrapper.scrollIntoView({ behaviour: 'smooth' });
                    }
                } else if (!__SERVER__) {
                    window.scroll({ top: 0, behavior: 'smooth' });
                }
                LocalStorage.removeData('scrollToCartridge', true);
                LocalStorage.removeData('galleryScrollToOffSet');
            }
        }
    }

    componentWillUnmount() {
        // fix for defect - MNPDPYODA-6719
        // window.removeEventListener('resize', this.renderCartridge);
        window.removeEventListener('orientationchange', this.renderCartridge);
    }

    onPaneClick(e, dataItem, linkUrlWithSlotId) {
        const {
            onPaneClick,
            productCartridgeList,
            featureFlags,
            fromMiniPDP,
            location: { pathname = '' },
            featureFlags: { enableAnchoring },
            isNative,
        } = this.props;
        if (onPaneClick) {
            e.preventDefault();
            e.stopPropagation();
            onPaneClick(
                dataItem.index,
                linkUrlWithSlotId,
                productCartridgeList[dataItem.index],
                this.quickAddToCartRefs[dataItem.id] &&
                    this.quickAddToCartRefs[dataItem.id].contains(e.target)
            );
        }
        if (featureFlags.enableMiniPDPOverPDP && !fromMiniPDP && dataItem.id) {
            this.enableMiniPdpOverPdp(dataItem, linkUrlWithSlotId);
        }
        const isGallery = validGalleryRoutes.some((route) => pathname.includes(route));
        if (isGallery && enableAnchoring) {
            const scrollKeyVal = {
                galleryScrollTo: this.props.slotId,
            };
            const scrollKey = { key: window.location.href, val: scrollKeyVal };
            scrollKeyVal && LocalStorage.setData('scrollToCartridge', scrollKey, true, '', false);
            // this is to set exact position where user clicked
            LocalStorage.setData('galleryScrollToOffSet', getScrolledElementOffSet());
            isNative &&
                Utils.findMobileOS() === 'iOS' &&
                setDefaultOffSet(dataItem.id, 'nativeGalleryScrollToOffSet');
        }
    }

    getPaginationButtons = () => {
        const { disableLeftArrow, disableRightArrow } = this.state;
        const leftArrowClass = cx({ iconClass: true, disabledArrow: disableLeftArrow });
        const rightArrowClass = cx({ iconClass: true, disabledArrow: disableRightArrow });
        return (
            <>
                <button
                    className={cx('arrow', 'leftArrow')}
                    disabled={disableLeftArrow}
                    onClick={() => this.scrollCartridge(false)}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={leftArrowClass}
                    >
                        <ArrowLeft />
                    </Icon>
                </button>
                <button
                    className={cx('arrow', 'rightArrow')}
                    disabled={disableRightArrow}
                    onClick={() => this.scrollCartridge(true)}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={rightArrowClass}
                    >
                        <ArrowRight />
                    </Icon>
                </button>
            </>
        );
    };

    getDots = () => {
        const carousel = this.getDimensions();
        if (!carousel) return null;
        const numberOfDots = Math.ceil(carousel.totalProductPanes / carousel.productPanesDisplayed);
        const generateDots = () => {
            const listDots = [];
            for (let i = 1; i <= numberOfDots; i += 1) {
                let checkStatus = false;
                if (this.state.currentDotIndex === i) {
                    checkStatus = true;
                }
                listDots.push(
                    <li className={cx('carosuelDot', checkStatus ? 'dotChecked' : '')} />
                );
            }
            return listDots.length > 1 ? listDots : [];
        };

        return <ul className={cx('carousel')}>{generateDots()}</ul>;
    };

    getDimensions(scroll) {
        /*
          included extra condition for https://jira.jcpenney.com/browse/MNPDPYODA-9006
        */
        const wrapperWidth = this.wrapper ? this.wrapper.getBoundingClientRect().width : 0;
        if (
            this.dimensions === null ||
            this.dimensions.wrapperWidth !== wrapperWidth ||
            this.orientationChangeValue
        ) {
            this.orientationChangeValue = false;
            if (scroll && this.scrollStatus.scrolledPanes) {
                this.resetScrollStatus();
                return null;
            }
            this.calculateDimensions(wrapperWidth);
        }
        return this.dimensions;
    }

    quickAddToCartRefs = {};

    enableMiniPdpOverPdp = (dataItem, linkUrlWithSlotId) => {
        const PDPUrl = linkUrlWithSlotId || `/p/product/${dataItem.id}?pTmplType=regular`;
        const selections = {
            skuId: '',
            ppId: dataItem.id,
            url: PDPUrl,
        };
        this.props.actions.selectProduct(selections);
        this.props.actions.showLazy('miniPDP');
        this.props.actions.showLoader();
    };

    resetScrollStatus = () => {
        this.scrollStatus.scrollPixels = 0;
        this.scrollStatus.scrolledPanes = 0;
        this.setState({
            listStyle: {
                transform: 'translate(0px)',
            },
            disableLeftArrow: true,
            disableRightArrow: false,
        });
    };

    isCardPartiallyDisplayed = (result = 0, roundedResult = 0) => {
        const partialCutoffThreshold = 0.1;
        return roundedResult - result > partialCutoffThreshold;
    };

    calculateDimensions = (wrapperWidth) => {
        const { productCartridgeList, deviceType, displayPartial, panelType } = this.props;
        const pane = this.props.productPane || this.productPane;
        const paneWidth = pane
            ? pane.getBoundingClientRect().width +
              parseFloat(window.getComputedStyle(pane).marginLeft) * 2
            : 0;

        if (paneWidth !== 0) {
            const totalProductPanes = productCartridgeList.length;
            const result = wrapperWidth / paneWidth;
            const roundedResult = Math.round(result);

            let productPanesDisplayed =
                result &&
                roundedResult &&
                (this.isCardPartiallyDisplayed(result, roundedResult) && !displayPartial
                    ? Math.floor(result)
                    : roundedResult);
            if (panelType === 'HOTDEAL') {
                productPanesDisplayed = Math.floor(result);
            }
            if (deviceType.isDesktop) {
                const leftPos = this.scrollStatus.scrollPixels;
                const extraPanes = Math.floor(leftPos / paneWidth);
                productPanesDisplayed += Math.abs(extraPanes);
            }
            this.dimensions = {
                wrapperWidth,
                paneWidth,
                totalProductPanes,
                productPanesDisplayed,
            };
        }
    };

    dimensions = null;

    scrollStatus = {
        scrollPixels: 0,
        scrolledPanes: 0,
    };

    scrollCartridge = (scrollToRight) => {
        const carousel = this.getDimensions(true);
        const { scrollPixels, scrolledPanes } = this.scrollStatus;

        if (carousel) {
            // Calculate number of products displayed in the container
            const { totalProductPanes } = carousel;
            const productPaneWidth = carousel.paneWidth;
            const result = carousel.wrapperWidth / carousel.paneWidth;
            const { productPanesDisplayed } = carousel;
            const remainingWrapperWidth =
                (result - productPanesDisplayed).toFixed(2) * productPaneWidth;

            const mountedCartrdigeInfo = {
                productPanesDisplayed,
                totalProductPanes,
                scrollPixels,
                scrolledPanes,
                productPaneWidth,
                scrollToRight,
                remainingWrapperWidth,
                disableRightArrow: this.state.disableRightArrow,
                isCouponRecommendationsModal: this.props.isCouponRecommendationsModal,
            };

            const {
                scrollContentBy,
                productPanesScrolled,
                migratedProductPanes,
            } = calculateScrollPixel(mountedCartrdigeInfo);

            this.scrollStatus.scrollPixels = scrollContentBy;
            this.scrollStatus.scrolledPanes = productPanesScrolled;

            const updatedState = {
                disableLeftArrow: migratedProductPanes === 0,
                disableRightArrow: migratedProductPanes === totalProductPanes,
                listStyle: {
                    transform: `translate(${scrollContentBy}px)`,
                },
            };

            if (scrollToRight && this.state.cardsToRender < migratedProductPanes) {
                updatedState.cardsToRender = migratedProductPanes + 1;
                this.props.onPaneRender &&
                    this.props.onPaneRender(this.state.cardsToRender, updatedState.cardsToRender);
            }

            this.setState(updatedState);
        }
    };

    defaultProductCardRenderer = (dataItem) => {
        const {
            slotId,
            isPLAEnabled,
            showPaneLoader,
            showImageLoader,
            pricingConfig,
            deviceType,
            showPricing,
            enableMiniPDP,
            productItemClass,
            enableUrgencyMessagingOnATC,
            urgencyMessages,
            preferences,
            isCouponRecommendationsModal,
            featureFlags,
            fromMiniPDP,
            criteriaName,
            enableGridViewInCertona,
        } = this.props;
        const { disableFPACAPI } = pricingConfig;
        let { cardsToRender } = this.state;
        cardsToRender = this.props.disableLazyLoad
            ? this.props.productCartridgeList.length
            : cardsToRender;
        const {
            linkURL,
            imageURL,
            name,
            rating,
            reviews,
            skuId,
            skuSwatch,
            index,
            priceDetails,
            id,
        } = dataItem;
        const map = get(preferences, 'recommendations.adobeMap', {});
        const rrPlacementType = map[slotId] || slotId;
        /* istanbul ignore next */
        let linkUrlWithSlotId =
            slotId && linkURL ? linkURL.concat(`&rrplacementtype=${rrPlacementType}`) : linkURL;
        linkUrlWithSlotId = criteriaName
            ? `${linkUrlWithSlotId}&criteriaName=${criteriaName}`
            : linkUrlWithSlotId;
        const linkwithoutHostName = Utils.getPathFromUrl(linkUrlWithSlotId);
        const enableNewPriceFormat = disableFPACAPI === false;
        const currentUrgencyMessage = enableUrgencyMessagingOnATC
            ? get(urgencyMessages, dataItem.id)
            : {};
        const prodCardStyle = enableMiniPDP
            ? cx('productCard', 'miniPdpProductCard', {
                  cartridgeNewPriceWrapper: enableNewPriceFormat,
              })
            : cx('productCard', 'productCatridge', {
                  cartridgeNewPriceWrapper: enableNewPriceFormat,
              });
        return (
            <a
                href={
                    featureFlags.enableMiniPDPOverPDP && !fromMiniPDP
                        ? 'javascript:void(0)'
                        : linkwithoutHostName
                }
                className={cx('linkColor', 'productPanelLinkBlock', productItemClass, {
                    couponRecommendationsPaneLink: isCouponRecommendationsModal,
                })}
                data-automation-id="reczone-link"
                ref={(productPane) => {
                    this.productPane = productPane;
                }}
                onClick={(e) => {
                    this.onPaneClick(e, dataItem, linkwithoutHostName);
                }}
            >
                {!isEmpty(currentUrgencyMessage) ? (
                    <span>
                        <UrgencyMessage
                            urgencyStatements={currentUrgencyMessage}
                            className={cx('urgencyMessage')}
                        />
                    </span>
                ) : null}
                <ProductCard
                    lazyLoadImages={!enableGridViewInCertona && !featureFlags.disableRRZoneLazyLoad}
                    customClass={prodCardStyle} // {cx('productCard', 'productCatridge', { newPriceProdCatridge: (disableFPACAPI === false) })}
                    imageUrl={imageURL}
                    title={!isPLAEnabled ? name : null}
                    price={priceDetails}
                    pricingConfig={pricingConfig}
                    key={id}
                    cardType={config.cardTypes.GRID}
                    rating={!isPLAEnabled ? Number(rating) : 0}
                    reviewCount={!isPLAEnabled ? reviews : 0}
                    cardTheme="cartridge"
                    cardCustomClass={cx('miniPdpCard')}
                    skuId={skuId}
                    skuSwatch={skuSwatch}
                    automationId="product-cartridge-product-list"
                    shallowCard={index >= cardsToRender}
                    showPaneLoader={showPaneLoader}
                    showImageLoader={showImageLoader}
                    showPricing={showPricing}
                    deviceType={deviceType}
                    eligibilityMessage={(priceDetails || {}).eligibilityMessage || ''}
                    isCouponRecommendationsModal
                    defaultOffSet={getDefaultOffSet('galleryScrollToOffSet', false) || 1000}
                >
                    {enableMiniPDP ? miniPDP(dataItem, linkUrlWithSlotId, id, this) : false}
                </ProductCard>
            </a>
        );
    };

    productCardRenderer = (dataItem) => {
        const { customRenderProductCard } = this.props;
        if (customRenderProductCard) {
            return this.props.cartridgeListRenderer(dataItem, this, this.props.highlightCardSlot);
        }

        return this.defaultProductCardRenderer(dataItem);
    };

    disableRightArrowOnLoad = (wrapper) => {
        this.wrapper = wrapper;
        const carousel = this.getDimensions();
        if (this.props.deviceType.isDesktop && !this.initialLoad && carousel) {
            // Calculate the total productPanesWidth
            const productPanesWidth = carousel.totalProductPanes * carousel.paneWidth;
            this.initialLoad = true;
            if (productPanesWidth < carousel.wrapperWidth)
                this.setState({ disableRightArrow: true });
        }
    };

    /* istanbul ignore next */
    delayedExec = (after, fn) => {
        /* istanbul ignore next */
        this.timer && clearTimeout(this.timer);
        /* istanbul ignore next */
        this.timer = setTimeout(fn, after);
    };

    updateDotsPosition = () => {
        const carousel = this.getDimensions();

        // Calculate number of products displayed in the container
        const dots = Math.ceil(carousel.totalProductPanes / carousel.productPanesDisplayed);

        /* istanbul ignore else */
        if (!__SERVER__) {
            const seletor = cx('listStyleClass');
            // const element = document.querySelector(`.${seletor}`).parentNode;
            // const element = this.cartridgeElement.querySelector(`.${seletor}`).parentNode;
            const elementDOMObj = document.getElementById(this.props.slotId);
            /* istanbul ignore next */
            const element = elementDOMObj
                ? elementDOMObj.querySelector(`.${seletor}`).parentNode
                : 0;
            const { scrollLeft } = element;
            const maxScrollWidth = (dots - 1) * carousel.productPanesDisplayed * carousel.paneWidth;
            const minscroll = maxScrollWidth / dots;
            let currentPaneSlot = Math.ceil(scrollLeft / minscroll);
            /* istanbul ignore next */
            if (currentPaneSlot <= 0) {
                currentPaneSlot = 1;
            }
            /* istanbul ignore next */
            if (currentPaneSlot > dots) {
                currentPaneSlot = dots;
            }

            const updatedState = {
                currentDotIndex: currentPaneSlot,
            };
            const productToRender =
                Math.ceil((maxScrollWidth + scrollLeft) / carousel.paneWidth) + 1;
            if (this.state.cardsToRender < productToRender) {
                updatedState.cardsToRender = productToRender;
                this.props.onPaneRender &&
                    this.props.onPaneRender(this.state.cardsToRender, updatedState.cardsToRender);
            }
            this.setState(updatedState);
        }
        return null;
    };

    indexList = (list) => {
        for (let i = 0; i < list.length; i += 1) {
            if (typeof list[i].index === 'undefined') {
                list[i].index = i;
            }
        }
    };

    listenScrollEvent = () => {
        /* istanbul ignore next */
        this.delayedExec(100, () => {
            this.updateDotsPosition();
        });
    };

    /**
     * stripping zero priced product items
     */
    isPriceEmpty = (item) =>
        (!item.originalMax || item.originalMax === '0') &&
        (!item.originalMin || item.originalMin === '0') &&
        (!item.currentMin || item.currentMin === '0') &&
        (!item.currentMax || item.currentMax === '0');

    fireEnsightenEvent = (productCartridgeList) => {
        const { pageType, panelType, cartridgeHeader, panelTitle } = this.props;
        const ppIds = productCartridgeList.reduce((result, item) => {
            if (
                (panelType === 'HOTDEAL' && this.isPriceEmpty(item)) ||
                (panelType === 'CERTONA' && !item.priceDetails)
            ) {
                result.push(item.ppId || item.id);
            }
            return result;
        }, []);
        if (ppIds.length > 0) {
            this.props.actions.triggerEnsightenEvent({
                pageType,
                errorType: 'Price Not Found',
                errorDescription: `${cartridgeHeader || panelTitle}: No price info for ${ppIds.join(
                    ','
                )}`,
            });
        }
    };

    renderPanes = () => {
        const { cardsToRender } = this.state;
        const carousel = this.getDimensions();
        if (carousel && cardsToRender >= carousel.totalProductPanes) {
            return;
        }
        if (carousel && cardsToRender < carousel.productPanesDisplayed) {
            this.setState({ cardsToRender: carousel.productPanesDisplayed });
            this.props.onPaneRender &&
                this.props.onPaneRender(this.state.cardsToRender, carousel.productPanesDisplayed);
        }
    };

    renderCartridge = (isOrientationChange = false) => {
        if (isOrientationChange) {
            this.orientationChangeValue = true;
        }
        this.calculateDimensions();
        this.renderPanes();
    };

    render() {
        const {
            deviceType,
            theme,
            productCatridgeTheme,
            productCartridgeList,
            prodCatridgeWrapper,
            cartridgeHeader,
            isPLAEnabled,
            pricingConfig,
            enableGridViewInCertona,
            listBodyClassTheme,
            highlightCardSlot,
            hasTitle,
            isCouponRecommendationsModal,
            isDrawer,
        } = this.props;
        const { disableFPACAPI } = pricingConfig;
        let listBodyClass = deviceType.isDesktop ? 'desktopBodyClass' : 'mobileBodyClass';
        listBodyClass = listBodyClassTheme || listBodyClass;
        const { listStyle } = this.state;
        let titleGrid = '';
        let cartridgeGrid = '';
        let titlePLAClass = '';
        let flexWrap = '';
        let productCartridge = 'productCartridge';
        if (isPLAEnabled) {
            titleGrid = 'lg2 xl2';
            titlePLAClass = 'titlePLA';
            cartridgeGrid = 'lg10 xl10';
        }
        if (enableGridViewInCertona) {
            flexWrap = 'flexWrap';
            productCartridge = 'gridViewProductCartridge';
        }

        const productCartridgeLength = productCartridgeList.length;
        if (productCartridgeLength) {
            this.indexList(productCartridgeList);
            let arrowToDisplay = productCartridgeLength > 4;
            if (deviceType.isDesktop && isDrawer && !__SERVER__) {
                const carousel = this.getDimensions();
                if (
                    !arrowToDisplay &&
                    carousel &&
                    carousel.wrapperWidth < carousel.paneWidth * productCartridgeLength
                ) {
                    arrowToDisplay = productCartridgeLength > 3;
                }
            }
            const displayArrow = isDrawer ? arrowToDisplay : true;

            return (
                <section
                    className={cx(productCartridge, productCatridgeTheme, {
                        newProdCardWrapper: disableFPACAPI === false,
                    })}
                >
                    <div
                        className={cx('wrapper', prodCatridgeWrapper)}
                        ref={(wrapper) => {
                            !isPLAEnabled && wrapper && this.disableRightArrowOnLoad(wrapper);
                        }}
                    >
                        <div className={cx(titleGrid)}>
                            {hasTitle && (
                                <h5
                                    data-automation-id="product-catridge-title"
                                    className={cx('productCartridgeTitle', titlePLAClass)}
                                >
                                    {cartridgeHeader}
                                </h5>
                            )}
                        </div>
                        <div className={cx(cartridgeGrid)}>
                            <div
                                className={cx('prodCatridgeListBlock')}
                                id={this.props.slotId}
                                ref={(prodCatridgeListBlock) => {
                                    prodCatridgeListBlock &&
                                        this.disableRightArrowOnLoad(prodCatridgeListBlock);
                                }}
                            >
                                {!enableGridViewInCertona &&
                                deviceType.isDesktop &&
                                !highlightCardSlot &&
                                displayArrow
                                    ? this.getPaginationButtons()
                                    : ''}
                                <List
                                    datasource={productCartridgeList}
                                    listBodyClass={cx(listBodyClass)}
                                    listStyleClass={cx('listStyleClass', flexWrap, {
                                        couponRecommendationsList: isCouponRecommendationsModal,
                                    })}
                                    itemStyleClass={cx(
                                        'itemStyleClass',
                                        'xl3',
                                        'lg3',
                                        'md6',
                                        'sm10',
                                        theme,
                                        { newPriceFormatCardBlock: disableFPACAPI === false }
                                    )}
                                    childRenderer={this.productCardRenderer}
                                    automationId="product-cartridge-list"
                                    listStyle={listStyle}
                                    spacing="None"
                                    onScroll={
                                        !enableGridViewInCertona && !deviceType.isDesktop
                                            ? this.listenScrollEvent
                                            : null
                                    }
                                />
                            </div>
                        </div>
                        {!enableGridViewInCertona && !deviceType.isDesktop ? this.getDots() : null}
                    </div>
                </section>
            );
        }
        return null;
    }
}

export const mapStateToProps = ({ context, urgencyMessages }) => ({
    deviceType: context
        ? context.deviceType
        : { isMobile: false, isDesktop: true, isTablet: false },
    preferences: context && context.preferences,
    featureFlags: context && context.featureFlags,
    isNative: context && context.isNative,
    urgencyMessages,
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getUrgencyStatementsAction,
            ...LoaderAction,
            selectProduct,
            showLazy,
            ...actions,
        },
        dispatch
    ),
});

/* istanbul ignore next */
export default withRouter(
    compose(
        withReducerSaga([ProductCartridgeReducer], [watchEnsightenErrorRequest]),
        connect(mapStateToProps, mapDispatchToProps)
    )(YodaProductCartridge)
);
